import React, { Fragment, useEffect, useState } from 'react';
import { Button, Row, Col, Form } from 'react-bootstrap';
import PropTypes from 'prop-types';

import { requestFindPassword } from 'api/user';
import Modal from 'components/common-sfims/modal/Common';
import { onInputChange } from 'function/event';
import { getText } from 'function/language';
import { useConfirmModalState } from 'global/confirmModalState';
import useObjReducer from 'hooks/useObjReducer';
import { RESPONSE_CODE } from 'types/const';

/**
 * 비밀번호 찾기
 */
const FindPassword = ({ show, onHide }) => {
  /* recoil */
  const { setConfirmModal } = useConfirmModalState();

  /* state */
  // 비밀번호 찾기 요청 데이터
  const [findPasswordData, setFindPasswordData] = useObjReducer({});
  // 비밀번호 찾기 비활성화 여부
  const [isDisableFindPassword, setIsDisableFindPassword] = useState(false);
  // 유효성 여부
  const [isInvalid, setIsInvalid] = useState(false);

  /* watch */
  useEffect(() => {
    // 모달이 표시된 경우 데이터 초기화
    if (show) {
      setFindPasswordData({
        userId: '',
        email: ''
      });
    }
  }, [show]);

  /* event */
  // 비밀번호 찾기
  const onSubmit = async event => {
    event.preventDefault();

    if (!event.currentTarget.checkValidity()) {
      setIsInvalid(true);

      return;
    }

    let title = 'sendUserPwd';
    let message = 'sendUserPwdMessage';

    setIsDisableFindPassword(true);

    try {
      const { code } = await requestFindPassword(findPasswordData);

      if (code !== RESPONSE_CODE.Success) {
        throw new Error();
      }

      // 모달 숨김
      onHide();
    } catch {
      title = 'errorEmail';
      message = 'errorEmailMessage';
    } finally {
      setConfirmModal({
        isOpen: true,
        title,
        message
      });
      setIsDisableFindPassword(false);
    }
  };

  /* view */
  return (
    <Modal show={show} onHide={onHide}>
      <Fragment key="header">{getText('findUserPwd')}</Fragment>
      <Fragment key="body">
        <Form validated={isInvalid} noValidate onSubmit={onSubmit}>
          <Form.Group className="mb-3">
            <Form.Control
              type="text"
              value={findPasswordData.userId}
              autoFocus
              name="userId"
              placeholder={getText('userId')}
              required
              onChange={event => onInputChange(event, setFindPasswordData)}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Control
              type="email"
              value={findPasswordData.email}
              name="email"
              placeholder={getText('email')}
              required
              onChange={event => onInputChange(event, setFindPasswordData)}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Row className="align-items-center justify-content-end">
              <Col xs="auto">
                <Button disabled={isDisableFindPassword} type="submit">
                  {getText('sendUserPwd')}
                </Button>
                <Button variant="secondary" className="ms-2" onClick={onHide}>
                  {getText('cancel')}
                </Button>
              </Col>
            </Row>
          </Form.Group>
        </Form>
      </Fragment>
    </Modal>
  );
};

FindPassword.propTypes = {
  // 표시 여부
  show: PropTypes.bool,

  // 모달을 숨긴 경우 이벤트
  onHide: PropTypes.func
};
FindPassword.defaultProps = { show: false };

export default FindPassword;
